export default "__VITE_ASSET__CpLqwTRS__"